// extracted by mini-css-extract-plugin
module.exports = {"status":"agreement_status_status__1Gc8j"};